import './EmailAuthentication.css';
import React, { useState, useEffect, useRef } from 'react';
import { commonStyles, rtlStyles, ltrStyles } from './accountAuthorizationStyles';
import FormField from './components/FormField';
import SocialNav from '../atoms/SocialNav/SocialNav';
import Recaptcha from './components/Recaptcha';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { validateRequired, runValidations, validateEmailRegex } from './commomFunctions';
import { getUserCookie, getLatestUserCookie } from './user_session';
import { loaderToggle } from '../../utils/setUserCookie';
import { qsToObject } from '../../utils/querystring';
import { canUseDOM, get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Hjson from 'hjson';
import { SHA256 } from '../../utils/sha256';
import { fetchData } from '../../utils/fetchData';
import { CloseButton } from '../atoms/CloseButton/CloseButton';
import { LOCAL_STORAGE_KEY_LINK_TO_CAMPAIGN_SCRIPT_GENERATOR } from '../CampaignScriptGenerator/constants';
import { removeQueryString } from '../Listing';
import { useHistory } from 'react-router-dom';
import { LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR } from '../VideoScriptGenerator/constants';
// --- Part of the CampaignScriptGenerator component ---
export const redirectToCampaignScriptGenerator = () => {
  const linkToCampaignScriptGenerator = localStorage.getItem(LOCAL_STORAGE_KEY_LINK_TO_CAMPAIGN_SCRIPT_GENERATOR) || null;
  if (linkToCampaignScriptGenerator) {
    window.location.href = linkToCampaignScriptGenerator;
    return true;
  }
  return false;
};
// --- Part of the CampaignScriptGenerator component ---

// --- Part of the VideoScriptGenerator component ---
export const redirectToVideoScriptGenerator = () => {
  const linkToVideoScriptGenerator = localStorage.getItem(LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR) || null;
  if (linkToVideoScriptGenerator) {
    window.location.href = linkToVideoScriptGenerator;
    return true;
  }
  return false;
};
// --- Part of the VideoScriptGenerator component ---

const EmailAuthentication = _ref => {
  let {
    fields,
    params,
    getActiveStep,
    getEmail,
    getUserFirstName,
    setGlobalLoader,
    getRegisterData,
    requestEvisaToken,
    getEvisaToken,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  let history = useHistory();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const loginSuccess = get(fields, 'data.loginSuccess');
  const facebookAppId = get(fields, 'data.contextItem.facebookAppId.jss.value');
  const googleClientId = get(fields, 'data.contextItem.googleClientId.jss.value');
  const redirectHome = get(fields, 'data.contextItem.redirectPage.jss.value.href');
  const resetPasswordMessage = get(fields, 'data.datasource.resetPasswordMessage.jss.value');
  const resetPasswordIconCode = get(fields, 'data.datasource.resetPasswordIconCode.jss.value');
  const socialFBText = mapDictionary.get('Facebook');
  const socialGlText = mapDictionary.get('Google');
  const orSeperatorText = mapDictionary.get('Or');
  const LabelEmail = mapDictionary.get('Email');
  const ErrorEmailRequired = mapDictionary.get('FieldErrorRequiredEmail');
  const ErrorEmailFormatRequired = mapDictionary.get('FieldErrorFormatRequiredEmail');
  const recaptchErrorMessage = mapDictionary.get('FieldErrorRequierdRecaptcha');
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const formErrorNetworOrApiIssue = mapDictionary.get('LoginApiFailError');
  const [formResponseError, setFormResponseError] = useState('');
  const [bmCookies, setBMCookies] = useState({});
  const [passwordUpdatedBanner, setPasswordUpdatedBanner] = useState(false);
  const welcomeButtonLabel = get(fields, 'data.datasource.welcomeButtonLabel.jss.value');
  const loginStatus = getUserCookie().login_status;
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  let referBack = false;
  let referrer = '/';
  const socialPlatform = eventsAnalytics['registrationClick'];
  let urlParams = null;
  if (canUseDOM) {
    let urlParams = qsToObject(window.location.href);
    if (urlParams.redirect_url && urlParams.redirect_url.length) {
      referBack = true;
      referrer = urlParams.redirect_url;
    }
  }
  let homeURL;
  if (canUseDOM) {
    homeURL = window.location.origin;
    homeURL += redirectHome;
  }
  useEffect(() => {
    if (loginStatus) {
      if (canUseDOM) {
        if (redirectToCampaignScriptGenerator()) return;
        if (redirectToVideoScriptGenerator()) return;
        if (referBack) {
          getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
            setBMCookies({
              ak_bmsc: userCookie.ak_bmsc,
              bm_mi: userCookie.bm_mi,
              bm_sv: userCookie.bm_sv,
              bm_sz: userCookie.bm_sz,
              _abck: userCookie._abck
            });
            if (userCookie && userCookie.access_token) {
              window.location = referrer;
              fetchData({
                path: `${apiGlobal}/graphql/user`,
                options: {
                  method: 'POST',
                  body: JSON.stringify({
                    query: `{ userProfile { email } }`
                  })
                },
                authToken: userCookie.access_token
              }).then(data => {
                const {
                  email: ddd
                } = data.data.userProfile;
                const encrEmail = SHA256(ddd);
                if (typeof window !== 'undefined') {
                  const wind = window;
                  if (wind.utag_data) {
                    wind.utag_data.cust_id = encrEmail;
                  }
                  const utag_data = document.getElementById('utag_data');
                  if (utag_data && utag_data.innerHTML) {
                    const startIndex = utag_data.innerHTML.indexOf('{');
                    const data = Hjson.parse(utag_data.innerHTML.slice(startIndex));
                    data.cust_id = encrEmail;
                    utag_data.innerHTML = `var utag_data = ${JSON.stringify(data)}`;
                  }
                }
              });
            }
          });
        } else {
          window.location.href = homeURL;
        }
      }
    } else {
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(_ref2 => {
        let {
          ak_bmsc,
          bm_mi,
          bm_sv,
          bm_sz,
          _abck
        } = _ref2;
        return setBMCookies({
          ak_bmsc,
          bm_mi,
          bm_sv,
          bm_sz,
          _abck
        });
      });
    }
    if (canUseDOM) {
      let urlParams = qsToObject(window.location.href);
      if (urlParams.type === 'resetpassword') {
        setPasswordUpdatedBanner(true);
      }
    }
  }, []);
  let allErrors = [];
  const [recaptchaError, setRecaptchaError] = useState('');
  const recaptchaRef = useRef(null);

  // USER EMAIL field start
  const [userEmail, setUserEmail] = useState('');
  const [errorUserEmail, setErrorUserEmail] = useState('');
  const defaultMaxLength = 16;
  const emailAuthId = `auth_${LabelEmail}`;
  const userEmailFieldProps = {
    value: userEmail,
    fieldError: errorUserEmail,
    setError: setErrorUserEmail,
    label: LabelEmail,
    type: 'email',
    id: emailAuthId,
    name: emailAuthId,
    placeholder: '',
    labelLight: false,
    errorRequired: ErrorEmailRequired,
    autoComplete: 'email',
    maxLength: defaultMaxLength,
    errorValue: ErrorEmailFormatRequired,
    required: true,
    changeEvent: value => {
      setUserEmail(value);
    },
    blurEvent: value => {
      userEmailFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userEmail;
      return runValidations([validateRequired, validateEmailRegex], value, userEmailFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(userEmailFieldProps);
  // USER EMAIL field end

  useEffect(() => {
    if (userEmail) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [userEmail]);

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    for (const fieldObj of allErrors) {
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };
  const successFunction = platformName => {
    // tealiumClickFunc(tealiumMergeClickData(loginSuccess, { ...params, email: userEmail }), platformName);
    if (canUseDOM) {
      if (referBack) {
        window.location = referrer;
      } else {
        window.location.href = homeURL;
      }
    }
  };

  // Form submit handler
  const formSubmit = event => {
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      setGlobalLoader(true);
      authWithEmail();
    }
    event.preventDefault();
  };
  const authWithEmail = async () => {
    let formdata = new FormData();
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    formdata.append('client_id', clientId);
    formdata.append('g-recaptcha-response', recaptchaToken);
    let myHeaders = new Headers();
    // if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
    //   myHeaders.append(
    //     'Cookie',
    //     `
    // 	${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
    // 	${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
    // 	${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
    // 	${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
    // 	${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
    // `
    //   );
    // }

    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    getEmail(userEmail);
    await fetch(`${identityGlobal}/api/account/VerifyUser?email=${userEmail}`, requestOptions).then(response => {
      statusCode = response.status;
      return response.json();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = result;
      }
      if (statusCode === 200) {
        removeQueryString('type', history);
        getRegisterData();
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['registrationClick'], params), welcomeButtonLabel);
        if (responseObj.exist) {
          getUserFirstName(responseObj.firstName);
          getActiveStep('login');
        } else if (!responseObj.exist) {
          getActiveStep('register');
          if (responseObj.errors && responseObj.errors.length) {
            throw Error(responseObj.errors[0].code);
          }
        }
      } else if (statusCode === 400) {
        if (responseObj.errors && responseObj.errors.length) {
          throw Error(responseObj.errors[0].code);
        }
      } else {
        throw Error(formErrorNetworOrApiIssue);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      if (statusCode === 0) {
        setFormResponseError(formErrorNetworOrApiIssue);
      } else {
        setFormResponseError(error.message);
      }
    });
  };
  if (!fields) {
    console.warn('EmailAuthentication component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[EmailAuthentication component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "lr__form form-elements"
  }, /*#__PURE__*/React.createElement("form", {
    className: "w-100",
    onSubmit: event => formSubmit(event),
    noValidate: true
  }, /*#__PURE__*/React.createElement(FormField, userEmailFieldProps), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error server-error"
  }, formResponseError) : null, /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "submit",
    disabled: disableSubmit
  }, welcomeButtonLabel))), /*#__PURE__*/React.createElement("div", {
    className: "auth-lr__seperator"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label-large auth-lr__seperator-word"
  }, orSeperatorText)), /*#__PURE__*/React.createElement(GoogleOAuthProvider, {
    clientId: googleClientId
  }, /*#__PURE__*/React.createElement(SocialNav, {
    buttons: [{
      sm: 'gp',
      text: socialGlText
    }, {
      sm: 'fb',
      text: socialFBText
    }],
    showError: errorMessage => setFormResponseError(errorMessage),
    ApiError: formErrorNetworOrApiIssue,
    successFunction: successFunction,
    getEvisaToken: accessToken => getEvisaToken(accessToken),
    requestEvisaToken: requestEvisaToken,
    loadingFunc: state => {
      setGlobalLoader(state);
      loaderToggle(state, setDisableSubmit);
    },
    facebookAppId: facebookAppId,
    googleClientId: googleClientId,
    analytics: {
      socialPlatform,
      params
    }
  }))), passwordUpdatedBanner && /*#__PURE__*/React.createElement("div", {
    className: "alert-info"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: resetPasswordIconCode
    },
    className: " icon"
  }), /*#__PURE__*/React.createElement("span", null, " ", resetPasswordMessage), /*#__PURE__*/React.createElement(CloseButton, {
    className: "alert-info-close-btn",
    onClick: () => {
      setPasswordUpdatedBanner(false);
    }
  })));
};
const mainStyles = "m1xwyrmp";
const mainRtlStyles = "mjzzd7i";
const mainLtrStyles = "m1viy7lk";
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles} ${mainStyles}  ${rtl ? mainRtlStyles : mainLtrStyles} `
  }, children);
};
export default EmailAuthentication;